/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, files: NonNullable<unknown> }} Spaces_Toast_Files_SkippedInputs */



/**
* | output |
* | --- |
* | "{count} file(s) skipped: unsupported file type. Skipped files: {files}" |
*
* @param {Spaces_Toast_Files_SkippedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_files_skipped = /** @type {((inputs: Spaces_Toast_Files_SkippedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Files_SkippedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Datei(en) übersprungen: Dateityp nicht unterstützt. Übersprungene Dateien: ${i?.files}`)
	return /** @type {LocalizedString} */ (`${i?.count} file(s) skipped: unsupported file type. Skipped files: ${i?.files}`)
});